import axios from '@/plugins/axios';
import qs from 'qs';
import utils from '@/stores/utils';
import invitations from "./submodules/invitations";

const { getStorageKey } = utils;

const state = {
};

const mutations = {
};

const actions = {
    init({ commit, dispatch, state }, params) {
        dispatch('invitations/init', { filters: { ordering: '-creation_date', initiated: false } });
        dispatch('invitations/fetchInvitations');
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        invitations: invitations({
            storageKey: getStorageKey('invitations', 'default'),
            fieldsToSave: undefined // Save all filters
        }),
    },
};
